export default __webpack_public_path__ + "static/media/national-highways-logo.0172709d.svg";